import { CREATE_PASSWORD_SCHEMA } from '@shared/config';
import * as yup from 'yup';

export const resetPasswordValidationSchema = yup.object({
  password: CREATE_PASSWORD_SCHEMA,
});

export type ResetPasswordRequestData = yup.InferType<typeof resetPasswordValidationSchema>;
